import { mapActions } from "../reducer";

export const resetFocusPoint = () => mapActions.setFocusPoint();
